import { render, staticRenderFns } from "./ContentInfoWrapper.vue?vue&type=template&id=3de62bab&functional=true&lang=pug&"
import script from "./ContentInfoWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentInfoWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports